import { render, staticRenderFns } from "./link-right.vue?vue&type=template&id=5ad1cd8f"
import script from "./link-right.vue?vue&type=script&lang=js"
export * from "./link-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports